import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MediaCell } from '../../carousel-media-cell/carousel-media-cell.component';

@Component({
  selector: 'lib-img-wrapper',
  templateUrl: './img-wrapper.component.html',
  styleUrls: ['./img-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImgWrapperComponent {
  @Output() isLoadingEmitter: EventEmitter<boolean> = new EventEmitter();
  @Input() objectFit = '';
  @Input() borderRadius!: number;
  @Input()
  get image(): MediaCell { return this._image }
  set image(val: MediaCell) {
    this._image = val;
  }
  private _image: MediaCell = { src: '', type: 'image' };
  constructor() { }
  ngOnInit() {
    this.isLoadingEmitter?.emit(true)
  }
  imageHasLoaded() {
    this.isLoadingEmitter?.emit(false);
  }

}
